import { createAppAbility } from '@guuru/abilities-common';

export default createAppAbility();
